
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.946 13.125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_767","data-name":"Path 767","d":"M119.307,4.791a6.585,6.585,0,0,1-1.613.46c.26-.044.64-.513.793-.7a2.969,2.969,0,0,0,.536-.976c.013-.028.024-.063,0-.084a.092.092,0,0,0-.086.007,8.2,8.2,0,0,1-1.912.732.13.13,0,0,1-.132-.035,1.428,1.428,0,0,0-.167-.171,3.386,3.386,0,0,0-.926-.568,3.222,3.222,0,0,0-1.42-.228,3.384,3.384,0,0,0-1.348.38,3.46,3.46,0,0,0-1.087.888,3.345,3.345,0,0,0-.65,1.3,3.525,3.525,0,0,0-.034,1.373c.01.076,0,.087-.066.076a10.206,10.206,0,0,1-6.57-3.344c-.077-.087-.119-.087-.182.007a3.331,3.331,0,0,0,.568,3.936c.129.122.262.244.4.356a3.359,3.359,0,0,1-1.268-.356c-.076-.048-.115-.02-.122.067a2.028,2.028,0,0,0,.021.376,3.37,3.37,0,0,0,2.077,2.686,1.973,1.973,0,0,0,.421.129,3.784,3.784,0,0,1-1.244.038c-.09-.017-.125.028-.09.115a3.5,3.5,0,0,0,2.612,2.188c.119.021.237.021.356.048-.007.011-.014.011-.021.021a4.138,4.138,0,0,1-1.784.946,6.39,6.39,0,0,1-2.71.347c-.146-.022-.176-.02-.216,0s0,.059.042.1c.185.122.373.23.564.335a8.949,8.949,0,0,0,1.812.724,9.646,9.646,0,0,0,9.366-2.19,9.829,9.829,0,0,0,2.592-7.17c0-.1.122-.16.194-.215a6.309,6.309,0,0,0,1.275-1.325.4.4,0,0,0,.084-.254V4.791c0-.042,0-.029-.065,0","transform":"translate(-103.426 -3.218)","fill":"currentColor"}})])
          )
        }
      }
    